<section id="online-check-section" class="section-card-content">
  <form [formGroup]="onlineCheckForm">
    <p class="details tw-text-[15px] tw-text-[#0F2950]">
      Your IP Address and location will be recorded for fraud prevention purposes.
    </p>

    <div class="deposit-details tw-mt-[10px] tw-mb-[15px]">
      <div class="row">
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#0F2950]">
            Funds Available
          </span>
        </div>
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#0F2950]">1-3 business days </span>
        </div>
      </div>

      <div class="row">
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#0F2950]">Fees</span>
        </div>
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#0F2950]">None</span>
        </div>
      </div>

      <div class="row">
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#0F2950]">
            Maximum Withdrawal
          </span>
        </div>
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#0F2950]">
            ${{ ((balance > 1000) ? 1000 : balance) | number:'1.2' }}
          </span>
        </div>
      </div>

      <div class="row note">
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#0F2950]">
            Note:
          </span>
        </div>
        <div class="column">
          <span class="tw-text-[15px] tw-text-[#0F2950]">
            Pending deposits may lower available balance.
          </span>
        </div>
      </div>
    </div>

    <div class="deposit-details choose-account-list tw-mt-[32px] tw-mb-[35px]">
      <span class="tw-text-[16px]">Choose Account</span>
      <div
        *ngFor="let account of accounts$ | async; let i = index"
        (click)="chooseAccount('account-'+i, account?.AccountId)"
        class="row tw-mt-[5px]"
      >
        <div class="column">
          <span id="account-{{i}}" class="selector tw-flex"></span>
        </div>
        <div class="column tw-border-[#6298E2] tw-border-t-[1px] tw-pl-[7px]">
          <span class="tw-text-[16px] tw-text-[#0F2950]">
            {{ account?.AchName }} - {{account.AchAccount.toString() | slice:-4 }}
          </span>
        </div>
      </div>
    </div>

    <div class="amount-row tw-relative">
      <!-- Message section -->
      <!-- tw-top-[-18px] -->
      <span class="tw-absolute tw-bottom-[-19px] tw-right-[0px] tw-h-[18px] tw-block tw-pt-[2px]">

        <!-- Required -->
        <span
          class="tw-block tw-text-right tw-text-xs tw-text-[#D83A19]"
          *ngIf="formVal['amount'] && formVal['amount']?.errors
            && (formVal['amount'].touched || formVal['amount'].dirty)"
        >
          {{
            'Please enter valid amount.'
          }}
        </span>
      </span>

      <span class="amount-deposit-usd tw-block tw-text-[16px] tw-text-[#5D5D5D]">
        Amount to be Withdrawn
      </span>
      <input
        formControlName="amount"
        id="depositAmount"
        (keyup)="withdrawAmount()"
        type="number"
        class="amount tw-h-[38px] tw-text-[22px] tw-text-[#645858]"
        placeholder=""
        pattern="^\d+(\.\d{1,2})?$"
        amwager3DecimalInput
      />
    </div>

    <p class="notice1 tw-text-[14px] tw-text-[#0F2950] tw-mt-[30px] tw-mb-[22px]">
      I hereby authorize AmWager.com to initiate a credit,
      in the amount indicated, to my checking/savings
      account in the financial institution (Bank) identified
      by the routing number indicated, and bank to credit same to such account.
    </p>

    <div class="tw-flex tw-mt-[15px]">
      <ion-checkbox
        mode="md"
        [checked]="isAgree"
        (ionChange)="toggleCheckbox()"
        id="isAgree"
        class="tw-top-1 tw-mr-2 tw-mt-0 tw-mb-0"
        slot="start"
      >
      </ion-checkbox>
      <p (click)="toggleCheckbox()" class="isAgree tw-font-bold tw-text-[15px] tw-text-[#0F2950]">
        I Agree to the Above Terms and Confirm the shown information is correct.
      </p>
    </div>

    <button
      (click)="withdraw()"
      [ngClass]="{'active': (isAgree && accountId && !isProcessing && formVal['amount'].valid)}"
      [disabled]="!isAgree || !accountId || isProcessing || formVal['amount'].invalid"
      class="deposit-now tw-w-full tw-h-[41px] tw-text-[16px] tw-mt-[30px] tw-mb-[10px]"
    >
      Withdraw Now
    </button>

  </form>
</section>
